/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing order.
 */
import helpers from './../../../../utils/helpers';
import Forms from './../../../../utils/forms/forms';
import { mapGetters, mapMutations } from 'vuex';
import clientService from './../../../../services/client';
import orderTypeService from './../../../../services/orderType';
import orderService from './../../../../services/order';
import store from './../../../../store';
import invoiceService from './../../../../services/invoice';
import ediOrderService from './../../../../services/ediOrder';
import orderProductService from './../../../../services/orderProduct';
import packageUnitTypeService from './../../../../services/packageUnitType';
import packageService from './../../../../services/package';
import packageOrderProductService from './../../../../services/packageOrderProduct';
import countryService from './../../../../services/country';
import projectService from './../../../../services/project';
import DateMixin from './../../../../mixins/date';
import moment from 'moment';
import orderConfirmShipping from './../../../../components/orderConfirmShipping/orderConfirmShipping.vue';
import ediOrderConfirmShipping from './../../../../components/ediOrderConfirmShipping/ediOrderConfirmShipping.vue';
import orderConfirm from './../../../../components/orderConfirm/orderConfirm.vue';
import ediOrderConfirm from './../../../../components/ediOrderConfirm/ediOrderConfirm.vue';
import orderWarehousePopup from './../../../../components/orderWarehousePopup/orderWarehousePopup.vue';
import invoiceExternalPopup from './../../../../components/invoiceExternalPopup/invoiceExternalPopup.vue';
import order from '../../../../store/modules/order';

export default {
  data() {
    return {
      form: new Forms({
        orderTypeId: {
          value: '',
          type: 'select',
        },
        projectId: {
          value: '',
          type: 'select',
        },
        clientId: {
          value: '',
          type: 'select',
        },
        date: {
          value: '',
          type: 'date',
        },
        time: {
          value: '',
          type: 'time',
        },
        duration: {
          value: '',
          type: 'number',
        },
        details: {
          value: '',
          type: 'textarea',
        },
        referenceNumber: {
          value: '',
          type: 'text',
        },
        internalNote: {
          value: '',
          type: 'textarea',
        },
      }),
      ediForm: new Forms({
        deliveryDate: {
          value: '',
          type: 'date',
        },
      }),
      ediNon220Form: new Forms({
        orderNumber: {
          value: '',
          type: 'select',
        },
      }),
      packageForm: new Forms({
        packageUnitTypeId: {
          value: '',
          type: 'select',
        },
        packingLevel: {
          value: '',
          type: 'select',
        },
        parentId: {
          value: '',
          type: 'select',
        },
        sscc: {
          value: '',
          type: 'text',
        },
        orderId: {
          value: '',
          type: 'hidden',
        },
      }),
      successMessage: '',
      showModal: false,
      loading: false,
      loadingConfirm: false,
      loadingProcess: false,
      cancelLoading: false,
      isEDIOrder: false,
      loadingClient: false,
      tabIndex: '1',
      hasInventory: false,
      dropdownState: false,
      dropdownStateDelivery: false,
      dropdownStateInvoice: false,
      hasProduction: false,
      nextOrderId: null,
      previousOrderId: null,
      trackingUrl: '#',
      orderType: '',
      orderConfirmNotification: false,
      selectedPaperSize: '102x192mm',
      paperSizes: [
        { value: '102x192mm', name: '102x192mm' },
        { value: 'A4', name: 'A4' },
        { value: 'A5', name: 'A5' },
        { value: 'A6', name: 'A6' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      clients: 'allClientOptions',
      orders: 'allOrders',
      orderTypes: 'orderTypes',
      currentOrder: 'currentOrder',
      currentEdiOrder: 'currentEdiOrder',
      orderProducts: 'allOrderProducts',
      packageUnitTypes: 'allPackageUnitTypes',
      parentIds: 'deliveryPackages',
      packages: 'deliveryPackages',
      packageOrderProducts: 'allPackageOrderProducts',
      account: 'account',
      orderEvents: 'orderEvents',
      countries: 'allCountries',
      allProjects: 'allProjects',
    }),

    warehouseOption() {
      if ((this.currentOrder.orderType !== 'Wordpress') &&
        (this.currentOrder.orderStatus === 'created' ||
        this.currentOrder.orderStatus === 'out_of_stock' || this.currentOrder.orderStatus === 'received')) {
        return true;
      }
      if (this.currentOrder.warehouseId === 0) {
        return true;
      }
      return false;
    },

    /**
     * Check current warehouse if active
     */
    currentWarehouse() {
      if (this.currentOrder.warehouse.name !== 'undefined' && this.currentOrder.warehouse.isActive === true) {
        return this.currentOrder.warehouse.name;
      }
      return '';
    },

    /**
     * Get current order bill.
     */
    bill() {
      return this.currentOrder.bills.filter(
        b => b.billTypeId === 1
      )[0] || {};
    },

    /**
     * Get order bills.
     */
    bills() {
      return this.currentOrder.bills.filter(
        b => b.billTypeId === 1
      );
    },

    /**
     * Get credit notes for current order.
     */
    creditNotes() {
      return this.currentOrder.bills.filter(
        b => b.billTypeId === 2
      );
    },

    /**
     * Validates if the EDI is considered credit note.
     */
    isConsideredEDICreditNote() {
      return this.currentOrder.orderType === 'EDI' &&
        (this.currentEdiOrder.ediOrderTypeName === 'ZKA' || this.currentEdiOrder.ediOrderTypeName === 'ZRE');
    },

    /**
     * Checks if order can be cancelled.
     *
     * @return {Boolean}
     */
    canCancelOrder() {
      if (this.currentOrder.orderType === 'EDI') {
        return !this.isReadyToBeConfirmed;
      }
      if (this.currentOrder.orderType === 'Wordpress') {
        return false;
      }
      return [
        'created',
        'pending',
        'out_of_stock',
        'confirmed',
        'shipping_confirmed',
      ].includes(this.currentOrder.orderStatus);
    },

    /**
     * Checks if order can be cancelled.
     *
     * Allow users to cancel if date of delivery has not been reached.
     *
     * @return {Boolean}
     */
    canCancelEdiOrder() {
      return [
        'received',
        'created',
        'pending',
        'out_of_stock',
        'confirmed',
        'processed',
        'shipping_confirmed',
      ].includes(this.currentEdiOrder.ediOrderStatusName);
    },

    /**
     * If current Edi order has status confirmed.
     */
    isEdiConfirmed() {
      return this.currentEdiOrder.ediOrderStatusName === 'confirmed' || this.currentEdiOrder.ediOrderStatusName === 'shipping_confirmed';
    },

    /**
     * If current Edi order has status processed.
     */
    isEdiProcessed() {
      return this.currentEdiOrder.ediOrderStatusName === 'processed';
    },

    canConfirmOrder() {
      if (['created', 'pending', 'out_of_stock'].includes(this.currentOrder.orderStatus) && !['EDI', 'Wordpress'].includes(this.currentOrder.orderType)) {
        return true;
      }

      return false;
    },

    canConfirmAsOrdered() {
      if (this.currentOrder.orderType === 'EDI') {
        if (['created', 'pending', 'out_of_stock'].includes(this.currentEdiOrder.ediOrderStatusName) && this.currentOrder.orderType === 'EDI' && this.is220 && (this.isReadyToBeConfirmed || this.hasUnconfirmedOrderProduct)) {
          return true;
        }

        if (this.checkHasInventory && this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received' && !this.currentEdiOrder.hasOrderConfirmation) {
          return true;
        }
      }

      return false;
    },

    ediOrderHasPodButNotConfirmed() {
      if (this.checkHasInventory && this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received' && !this.currentEdiOrder.hasOrderConfirmation) {
        return true;
      }
      return false;
    },

    /**
     * If a invoice can be created.
     */
    canCreateInvoice() {
      if (this.currentOrder.ediOrderId) {
        if (this.currentOrder.isAsko || this.currentOrder.isRema || this.currentOrder.isCoop) {
          return (this.currentEdiOrder.ediOrderStatusName === 'shipping_confirmed');
        }

        if (this.checkHasInventory && !this.currentEdiOrder.hasOrderConfirmation && this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received') {
          return false;
        }

        return (this.isZNB || (this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received')); // || this.isZRE
      }

      if (['Transfer'].includes(this.currentOrder.orderType)) {
        return false;
      }

      return this.currentOrder.orderStatus !== 'cancelled';
    },

    /**
     * If a credit note can be created.
     */
    canCreateCreditNote() {
      if (this.currentOrder.ediOrderId) {
        return (this.isZRE || this.isZKA) && !this.currentOrder.isBilled && !this.isEdiOrderCancelled;
      }

      return false;
    },

    /**
     * Checks if order is already cancelled.
     *
     * @return {Boolean}
     */
    isCancelled() {
      return this.currentOrder.orderStatus === 'cancelled';
    },

    isEdiOrderCancelled() {
      return this.currentEdiOrder.ediOrderStatusName === 'cancelled';
    },

    isAskoAndBilled() {
      return this.currentOrder.isAsko && this.currentOrder.isBilled;
    },

    /**
     * Checks if appointment time has passed already.
     */
    isAppointmentCompleted() {
      const order = this.currentOrder;
      if (order.orderType !== 'Appointment') return false;
      const now = moment();
      const end = moment(`${order.date} ${order.time}`).add(order.duration, 'minutes');
      return now.isAfter(end);
    },

    /**
     * The current client for the order.
     */
    currentClient() {
      const client = Object.assign({}, this.currentOrder.client);
      if (this.currentOrder.orderType === 'EDI') {
        client.streetName = this.currentEdiOrder.ediStoreStreet || client.streetName;
        client.postalCode = this.currentEdiOrder.ediStorePostCode || client.postalCode;
      }
      if (client.countryId) {
        client.country = this.countries.items.find(item => item.id === client.countryId).name;
      }

      return client;
    },

    isZRE() {
      return this.currentEdiOrder.ediOrderTypeName === 'ZRE';
    },

    isZKA() {
      return this.currentEdiOrder.ediOrderTypeName === 'ZKA';
    },

    isZNB() {
      return this.currentEdiOrder.ediOrderTypeName === 'ZNB';
    },

    is220() {
      return this.currentEdiOrder.ediOrderTypeName === '220';
    },

    checkHasInventory() {
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Inventory') {
            return true;
          }
        }
      }

      return false;
    },

    isReadyToBeConfirmed() {
      if (this.orderProducts.some(orderProduct => orderProduct.quantityConfirmed > 0)) {
        return ['created', 'pending', 'out_of_stock'].includes(
          this.currentEdiOrder.ediOrderStatusName
        );
      }

      return false;
    },

    hasUnconfirmedOrderProduct() {
      if (this.currentOrder.orderType == 'EDI') {
        if (this.orderProducts.some(orderProduct => orderProduct.quantityConfirmed === null)) {
          return true;
        }
      }


      return false;
    },

    hasCancelledOrderProduct() {
      if (this.orderProducts.some(orderProduct => orderProduct.quantityConfirmed === 0)) {
        return true;
      }

      return false;
    },

    hasEdiOrderSource() {
      return this.currentEdiOrder.ediOrderSource > 0;
    },

    unassignedProducts() {
      return this.orderProducts.filter(op => op.quantityConfirmed != op.quantityPacked);
    },

    hasExciseModule() {
      let hasExciseModule = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Excise') {
            hasExciseModule = true;
          }
        }
      }
      return hasExciseModule;
    },

    hasBevearageProducts() {
      return this.orderProducts
        .filter(
          p =>
            p.productType === 'Beverage' || p.productTypeGroup === 'Beverage'
        ).length > 0;
    },
  },

  watch: {

    allProjects(allProjects) {
      const options = allProjects.map(project => ({
        id: project.id,
        name: project.name,
      }));
      this.form.setOptions('projectId', [{ id: 0, name: ' ' }, ...options]);
    },

    /**
     * Needed when the router changes
     * but the components needs
     * to be updated.
     */
    '$route.params.id': function () {
      this.show();
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} orderTypes    The order types list.
     */
    orderTypes() {
      this.manageOrderTypes();
      this.toggleAppointmentConfig();
    },

    /**
     * Watches order type to hide or show appointment config.
     */
    'form.orderTypeId': function () {
      this.toggleAppointmentConfig();
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} currentOrder The order.
     */
    currentOrder() {
      this.orderType = this.currentOrder.orderType ? this.currentOrder.orderType.toLowerCase() : '';
      this.manageOrderTypes();
      if (this.currentOrder.orderType && this.currentOrder.orderType.toLowerCase() === 'edi') {
        this.hideAppointmentConfig();
        this.form.hideField('clientId');
        this.form.hideField('orderTypeId');
        this.isEDIOrder = true;
        if (this.currentOrder.ediOrderId > 0) {
          Promise.all([
            ediOrderService.show(this.currentOrder.ediOrderId),
            packageService.all(this.currentOrder.id),
            packageOrderProductService.all(this.currentOrder.id),
          ])
            .then(() => {
              this.ediForm.deliveryDate = (this.currentEdiOrder.requestedDeliveryDate) ?
                new Date(moment(this.currentEdiOrder.requestedDeliveryDate).format('D/M/Y')) : new Date();
            });
        }
      }
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} currentOrder The order.
     */
    clients(clients) {
      this.form.setOptions('clientId', clients.map(c => ({ name: c.companyName || `${c.firstName} ${c.lastName}`, id: c.id })));
    },

    packageUnitTypes: {
      handler(packageUnitTypes) {
        this.packageForm.setOptions('packageUnitTypeId', packageUnitTypes.all || []);
      },
      immediate: true,
    },

    parentIds(parentIds) {
      this.packageForm.setOptions('parentId', parentIds.all.filter(p => p.packingLevel == 2));
    },

    /**
     * Watches the value of the client type.
     */
    'packageForm.packingLevel': function (typeId) {
      if (typeId.toString() == 2) {
        this.packageForm.hideField('parentId');
      } else if (typeId.toString() == 3) {
        this.packageForm.showField('parentId');
      }
    },
  },

  created() {
    // close dropdown if click outside
    const self = this;
    window.addEventListener('click', (e) => {
      if (helpers.closeDropdown(e, self.dropdownState) === false) self.dropdownState = false;
      if (helpers.closeDropdown(e, self.dropdownStateDelivery) === false) self.dropdownStateDelivery = false;
      if (helpers.closeDropdown(e, self.dropdownStateInvoice) === false) self.dropdownStateInvoice = false;
    });

    this.show();
    this.initializePackageForm();
  },

  destroyed() {
    this.resetEdiOrder();
    this.resetOrder();
  },

  methods: {
    checkProjectModule() {
      this.form.hideField('projectId');
      let hasProject = false;
      if (this.account.modules.length > 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name === 'Project') {
            hasProject = true;
          }
        }
      }
      if (hasProject) {
        this.form.showField('projectId');
      }
    },

    completeReturnOrder() {
      orderService.completeReturnOrder(this.currentOrder.id)
      .then(() => {
        this.$message({
          showClose: true,
          message: this.$t('static.ediOrders.edit.returnSuccess'),
          type: 'success',
        });
        Promise.all([
          orderService.show(store.state.route.params.id),
        ]);
      });
    },

    createReturnOrder() {
      orderService.returnOrder(this.currentOrder.id)
      .then((response) => {
        this.$router.push({
          name: 'orders.edit',
          params: {
            id: response.id,
          },
        });
      });
    },

    ...mapMutations({
      resetEdiOrder: 'RESET_CURRENT_EDI_ORDER',
      resetOrder: 'RESET_CURRENT_ORDER',
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalClass: 'SET_MODAL_CLASS',
      setModalProps: 'SET_MODAL_PROPS',
    }),

    /**
     * Activates the modal
     */
    activateInvoiceExternalModal() {
      this.setModalContent(() => invoiceExternalPopup);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Activates the modal
     */
    activateWarehouseModal() {
      this.setModalContent(() => orderWarehousePopup);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Activates the modal
     */
    activateModal() {
      this.setModalContent(() => orderConfirmShipping);
      this.setModalProps({
        warehouseId: this.currentOrder.warehouse.id,
        orderConfirmNotification: this.orderConfirmNotification,
      });
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Activates the modal
     */
    activateModalEDI() {
      this.setModalContent(() => ediOrderConfirmShipping);
      this.setModalProps({
        warehouseId: this.currentOrder.warehouse.id,
      });
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    showConfirmModalShipping() {
      if (this.currentOrder.orderType != 'EDI') {
        this.activateModal();
      } else {
        this.activateModalEDI();
      }
    },

    /**
     * Activates the modal
     */
    activateModalEdi() {
      this.setModalClass('order-confirm');
      this.setModalContent(() => ediOrderConfirm);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Activates the modal
     */
    activateModalConfirm() {
      this.setModalClass('order-confirm');
      this.setModalContent(() => orderConfirm);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Show shipping order
     */
    showShippingOrder(value) {
      const routeData = this.$router.resolve({ name: 'orderPickups.index', query: { number: value } });
      window.open(routeData.href, '_blank');
    },

    /**
     * Scrolls to a specific portion of the page.
     */
    scrollWindow() {
      const container = this.$el.querySelector('.main-body');
      container.scrollTop = container.scrollHeight;
    },

    /**
     * Calculates whether to hide or show appointment's fields.
     */
    toggleAppointmentConfig() {
      const type = this.orderTypes.filter(t => (
        this.form.orderTypeId.toString() === t.id.toString()
      ));

      if (type.length === 0) {
        return;
      }

      if (type[0].name === 'Appointment') {
        this.showAppointmentConfig();
      } else {
        this.hideAppointmentConfig();
      }

      return;
    },

    /**
     * Set correct state for order types select input.
     */
    manageOrderTypes() {
      if (Object.keys(this.currentOrder).length === 0 || this.orderTypes.length === 0) {
        return;
      }

      const type = this.orderTypes.filter(t => (
        this.currentOrder.orderTypeId.toString() === t.id.toString()
      ));

      if (type.length > 0 && type[0].name === 'EDI') {
        this.form.hideField('orderTypeId');
        this.form.orderTypeId = type[0].id;
        return;
      }

      let allowedTypes = this.orderTypes.filter(t => t.name !== 'EDI');
      if (allowedTypes.length === 1) {
        this.form.hideField('orderTypeId');
        this.form.orderTypeId = allowedTypes[0].id;
        return;
      }

      allowedTypes = allowedTypes.map(allowedType => ({
        id: allowedType.id,
        name: this.$t(`static.orders.types.${allowedType.name.toLowerCase()}`),
      }));

      this.form.setOptions('orderTypeId', allowedTypes);
    },

    /**
     * Show appointment specific fields.
     */
    showAppointmentConfig() {
      this.form.showField('date');
      this.form.showField('time');
      this.form.showField('duration');
      this.form.showField('details');
      this.form.hideField('projectId');
    },

    /**
     * Hide appointment specific fields.
     */
    hideAppointmentConfig() {
      this.form.hideField('date');
      this.form.hideField('time');
      this.form.hideField('duration');
      this.form.hideField('details');
    },

    /**
     * Method to update the order.
     */
    store() {
      this.form.loading = true;
      orderService.update(store.state.route.params.id, this.form.data())
        .then(() => {
          this.form.loading = false;
          this.successMessage = this.$t('static.orders.edit.successMessage');
          setTimeout(() => {
            this.successMessage = '';
          }, 3000);
        }).catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },

    /**
     * Fetches resources needed for the page.
     */
    show() {
      this.loading = true;
      const requests = [
        orderService.show(store.state.route.params.id),
        orderService.getNextPreviousId(store.state.route.params.id),
        orderService.events(store.state.route.params.id),
        projectService.all(),
      ];
      if (!this.countries || (this.countries && !this.countries.items.length)) {
        requests.push(countryService.all());
      }
      if (!this.packageUnitTypes.all.length) {
        requests.push(packageUnitTypeService.all());
      }
      if (!this.orderTypes.length) {
        requests.push(orderTypeService.all());
      }
      if (!this.clients.length) {
        requests.push(clientService.allOptions());
      }
      Promise.all(requests).then((data) => {
        this.form.assignData(data[0]);
        this.nextOrderId = data[1].next;
        this.previousOrderId = data[1].previous;
        this.loading = false;
        this.checkProjectModule();
      });
    },

    /**
     * Confirms the edi order.
     */
    confirm() {
      if (this.currentOrder.orderType != 'EDI') {
        this.activateModalConfirm();
      } else {
        this.activateModalEdi();
      }
    },

    cancel() {
      this.$confirm(this.$t('static.ediOrders.edit.confirmCancel'), this.$t('static.orders.index.confirmCancelTitle'), {
        confirmButtonText: this.$t('button.yes'),
        cancelButtonText: this.$t('button.no'),
        type: 'warning',
      }).then(() => {
        this.cancelLoading = true;
        ediOrderService.cancel(this.currentEdiOrder.id, this.form.data())
          .then((data) => {
            this.cancelLoading = false;
            if (data.xml) {
              this.$msgbox({
                title: 'XML',
                message: data.xml,
                customClass: 'xmlModalCustomClass',
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$t('static.ediOrders.edit.cancelSuccess'),
                type: 'success',
              });
            }
            orderProductService.all(this.currentOrder.id);
          }).catch(() => {
            this.cancelLoading = false;
            this.$message({
              showClose: true,
              message: this.$t('static.ediOrders.edit.cancelError'),
              customClass: 'error',
            });
          });
      }).catch(() => {});
    },
    /**
     * Processes the edi order.
     */
    process() {
      this.loadingProcess = true;
      ediOrderService.process(this.currentEdiOrder.id, this.form.data())
        .then((data) => {
          this.loadingProcess = false;
          if (data.xml) {
            this.$msgbox({
              title: 'XML',
              message: data.xml,
              customClass: 'xmlModalCustomClass',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('static.ediOrders.edit.processSuccess'),
              type: 'success',
            });
          }
        }).catch(() => {
          this.loadingProcess = false;
          this.$message({
            showClose: true,
            message: this.$t('static.ediOrders.edit.processError'),
            type: 'error',
          });
        });
    },

    /**
     * Shows the pdf delivery note.
     */
    showPrintableDeliveryNote() {
      invoiceService.showDeliveryNote(this.currentOrder.hashid);
    },

    downloadPrintableDeliveryNote() {
      invoiceService.downloadDeliveryNote(this.currentOrder.hashid);
    },
    /**
     * Creates the invoice & redirects to the edit order page.
     */
    createInvoice() {
      ediOrderService.invoice(this.currentEdiOrder.id, this.form.data())
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$t('static.ediOrders.edit.invoiceSuccess'),
            type: 'success',
          });
        }).catch(() => {
          this.$message({
            showClose: true,
            message: this.$t('static.ediOrders.edit.invoiceError'),
            type: 'error',
          });
        });
    },

    /**
     * Creates the credit note & redirects to the edit order page.
     */
    createCreditNote() {
      if (this.checkHasInventory && !this.currentOrder.warehouseId && (this.isZRE || this.isZKA)) {
        this.activateWarehouseModal();
        return;
      }
      ediOrderService
        .creditNote(this.currentEdiOrder.id, this.form.data())
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$t('static.ediOrders.edit.creditSuccess'),
            type: 'success',
          });
        })
        .catch(({ response }) => {
          this.$message({
            showClose: true,
            message: response.data.error ? response.data.error.message : this.$t('static.ediOrders.edit.invoiceError'),
            customClass: 'error',
          });
        });
    },

    /**
     * Sends user to create a bill for this order.
     */
    createBill() {
      if (this.isZNB && this.hasBevearageProducts && this.hasExciseModule) {
        if (!this.currentOrder.warehouseId) {
          this.activateWarehouseModal();
        } else {
          this.activateModalEdi();
        }
        return;
      }

      this.$router.push({
        name: 'bills.create',
        query: {
          order: store.state.route.params.id,
        },
      });
    },

    /**
     * Sends request to cancel order.
     */
    cancelOrder() {
      this.$confirm(this.$t('static.ediOrders.edit.confirmCancel'), this.$t('static.orders.index.confirmCancelTitle'), {
        confirmButtonText: this.$t('button.yes'),
        cancelButtonText: this.$t('button.no'),
        type: 'warning',
      }).then(() => {
        this.cancelLoading = true;
        orderService.destroy(store.state.route.params.id)
          .then(() => {
            this.$router.push({
              name: 'orders.index',
            });
            this.cancelLoading = false;
          }).catch(() => {
            this.$message({
              showClose: true,
              message: this.$t('static.orders.edit.cancelError'),
              type: 'error',
            });
            this.cancelLoading = false;
          });
      });
    },
    toggleDropdown() {
      this.dropdownState = !this.dropdownState;
    },

    toggleDropdownDelivery() {
      this.dropdownStateDelivery = !this.dropdownStateDelivery;
    },

    toggleDropdownInvoice() {
      this.dropdownStateInvoice = !this.dropdownStateInvoice;
    },

    confirmAsOrdered() {
      this.dropdownState = !this.dropdownState;
      const me = this;
      Promise.all([orderService.confirmAsOrdered(this.currentOrder.id)]).then((data) => {
        me.confirm();
      });
    },

    nextOrder() {
      if (!this.nextOrderId) {
        return;
      }
      this.navigate(this.nextOrderId);
    },

    previousOrder() {
      if (!this.previousOrderId) {
        return;
      }
      this.navigate(this.previousOrderId);
    },

    navigate(id) {
      this.$router.push({
        name: 'orders.edit',
        params: {
          id,
        },
      });
    },

    /**
     * Hide parentId field and  dropdown value of package type.
     */
    initializePackageForm() {
      const type = [
        { id: '2', name: 'Pallet' },
        { id: '3', name: 'Box' },
      ];
      this.packageForm.setOptions('packingLevel', type);
      this.packageForm.hideField('parentId');
    },

    createPackage() {
      this.packageForm.loading = true;
      this.packageForm.orderId = this.currentOrder.id;
      this.savePackage();
    },

    savePackage() {
      packageService.store(this.packageForm.data())
        .then(() => {
          this.successMessage = this.$t('static.orders.package.created');
          setTimeout(() => {
            this.successMessage = '';
          }, 3000);
          this.packageForm.loading = false;
          packageService.all(this.currentOrder.id);
        }).catch((errors) => {
          this.packageForm.loading = false;
          this.packageForm.recordErrors(errors);
          this.$message({
            showClose: true,
            message: this.$t('static.orders.package.error'),
            customClass: 'error',
          });
        });
    },

    downloadShippingLabel() {
      orderService.downloadShippingLabel(this.currentOrder.id, this.selectedPaperSize);
    },

    downloadPalletLabel() {
      orderService.downloadPalletLabel(this.currentOrder.id, this.selectedPaperSize);
    },

    invoiceExternal() {
      this.activateInvoiceExternalModal();
    },

    // assignProductToPackage(quantity) {

    // }

  },
  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VMessage: require('./../../../../components/form/message/message.vue'),
    VProductsTable: require('./../../../../components/orderProductsTable/orderProductsTable.vue'),
    VEdiOrderItemsTable: require('./../../../../components/ediOrderItemsTable/ediOrderItemsTable.vue'),
    VManagePackage: require('./../../../../components/managePackage/managePackage.vue'),
    VOriginalOrderItemsTable: require('./../../../../components/originalOrderItems/originalOrderItems.vue'),
    VSelect: require('./../../../../components/form/select/select.vue'),
    VClientInfo: require('./../../../../components/clientInfo/clientInfo.vue'),
  },

  mixins: [
    DateMixin,
  ],

};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/orders/edit/edit.js